/*
 * @Description: 
 * @version: v1.0.0
 * @Author: ladd
 * @Date: 2026-03-17 16:18:34
 * @LastEditors: ladd
 * @LastEditTime: 2026-03-17 16:37:40
 */
export default {
  route: {
    dashboard: '首页',
    todolist: '待办事项',
    customer:'账户管理',
    customerInfo:'客户信息',

    contract:'销售管理',
    contractInfo:'合同详情',
    contractList:'销售合同',
    accountList:'应收账款',
    contractDetail: "合同详情",
    contractEdit:'编辑合同',
    contractAdd:'添加合同',
    accountDetail:'应收款详情',
    activity:'活动管理',
    activityList:'活动信息',
    batch:'批次管理',
    batchInfo:'批次信息',
    emailConfig:'邮件统计数据',
    basic:'基础设置',
    menberManagement:'人员管理',
    roleManagement:'角色管理',
    menuManagement:'菜单管理',
    logManagement:'日志管理',
    configNotice:'配置通知',
    stockDetail:'批次详情',
    stockData:'月度审计报表',
    costTransfer:'成本转移',
    BillingInformation:'客户账户信息',
    contractRelated:'关联合同',
    companyAccountList:'公司账户信息',
    invoiceManagement:'开票管理',
    CollectionInformation:'收款管理',
    refundManagement:'退款管理',
    dataVerification:'数据核查',
    MissingBatch:'遗漏批次',
    ProjectSummary:'项目汇总',
    ownerInformation:'归属方信息',
    BillAndCollectChecked:'开票收款校验',
    batchDetailsDownload:'批次明细下载',
    pinganPayDetailsDownload: '平安付明细下载',
    OperationReconciliationLag:'运营对账滞后',
    DownLoadApply:'打印下载表',
    PingAnBatch:'平安铺底批次',
    citicBatch:'中信微信批次业务属性',
    citicBatchAlipay  :'中信支付宝批次业务属性',
    citicThird:'中信敏捷对账',
    thirdPartBenefits: '第三方权益',
    supplierContractList:'采购合同',
    supplierManagement:'采购管理',
    supplierContractDetail:'合同详情',
    supplierContractEdit:'编辑合同',
    supplierContractAdd:'添加合同',
    paymentManagement:'打款管理',
    supplierAccountInformation:'供应商账户信息',
    billReceiptManagement:'收票管理',
    supplierDownLoadApply:'打印下载表',
    returnManagement:'返还管理',
    dolphinDetails:'海豚明细数据',
    wxStock:'批次信息查询',
    taobaoDetails:'淘宝免密活动数据',
    jiaheAlipay:'嘉禾支付宝数据',
    cloudxDetails:'云闪付数据',
    meituanDetail:'美团数据',
    douyinData:'抖音数据',
    merchant365TagStatistics:'商编&365标签统计数据',
    BatchReleaseFounds: '应释放资金批次',
    business:'商务管理',
    depositManagemant:'保证金管理',
    AiCheckManagement:'AI审查管理',
    procurementBids:'采购标书管理',
    wxsnapshot:'微信批次快照',
    voucherComparison:'明细凭证比对',
    citicBatchAlipayNew:'支付宝-商编-业务属性-分中心',
    citicBatchWX1:'微信-商编-业务属性',
    citicBatchWX2:'微信-批次-分中心',
    citicBatchWX3:'微信-批次-商编-分中心',
    citicBatchWX3_plus:'微信-批次-商编-分中心-业务归属',
    citicBatchWX4:'微信-批次-业务属性',
    citicBatchWX5:'微信-批次-协同',
    citicBatchWX6:'微信-商编-协同',
    citicBatchWX7:'微信-批次-档位',
    citicBatchWXExt3:'扩展字段3-批次-内容',
    citicStockAmount:'第三方批次-每日配置金额',
    citicBatchWX8:'微信-商编-品牌',
    '365tag' : '精彩365商户标签&商批映射', 
    onlinePublishActivityMapping:'挂网活动信息映射管理',
    email:'对账所需数据',
    emailDetail:'对账所需数据详情',
    zxMerchantCheck:'中信商户号在线情况校验',
    stockCheck:'数据质量检测',
    pinganMerchant: '平安商编管理',
    merchantTask: '商编任务',
    merchantList:'商编列表',
    merchant:'商户号管理',
    batchMerchant:'批次商户号',
    merchantCheck:'商户号校验',
    merchantCheckDetail:'商户号校验详情',
    batchMerchantDetail:'批次商户号详情',
    zx365:'中信精彩365',
    cloudxStockManagement:'云闪付批次管理',
    cloudxBatchQuery:'云闪付批量查询',
    cloudxBatchDetail:'云闪付批量查询详情',
    package: '银行号码包管理',
    bankPackage: '银行号码包',
    packageBatch: '批量创建号码包',
    packageDetail:'银行号码包详情',
    packageAlipay:'支付宝号码包',
    merchantAutoTask:'商户号自动校验',
    merchantAutoTaskDetail:'商户号自动校验详情',
    dataAnalysisEmail:'月度核销数据统计分析',
    seal: '印章管理',
    sealManagemant: '用印管理',
    bidReview:'标书审核',
    otherBill:'其他费用管理',
    toolManagement:'工具管理',
      sftpManagement:'SFTP管理',
      documentType:'制度文件类型',
      administrative:'行政综合管理',
      documentCenter:'制度文件中心',
  },
  login: {
    logIn: '登录',
    username: '请输入管理员名称',
    password: '请输入管理员密码',
    validcode: '请输入图片验证码',
    val_username: '请输入管理员名称',
    val_password: '请输入管理员密码',
    val_validcode: '请输入图片验证码',
    val_form: '表单填写有误，请检查！'
  },
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js